export default __webpack_public_path__ + "static/mkbsd-logo-20-jaar-5d5fbba5d308487ec9294de92dcc5b08.svg";